import { createFileRoute } from "@tanstack/react-router"

import { WallGraphic } from "@/components/wall/WallGraphic"
import { IntroContent } from "@/sections/layouts/IntroContent"

export const Route = createFileRoute("/$sessionId/_session/intro/welcome")({
  component: IntroWelcomeRoute,
})

function IntroWelcomeRoute() {
  const { sessionId } = Route.useParams()

  return (
    <IntroContent
      aboveHeading={<WallGraphic type="LetsGoHouse" />}
      activeStepIndex={1}
      numberOfSteps={5}
      linkProps={{ to: "/$sessionId/intro/permissions", params: { sessionId } }}
      heading={{
        i18nKey: "intro.welcome.heading",
      }}
      description={{
        i18nKey: "intro.welcome.description",
      }}
    />
  )
}
